import React from "react";
import styled from "styled-components";
import { Row, Col } from "reactstrap";
import { HeaderTitle, PrimaryButton } from "../../../../utils/budget-tool-specific";
import { useParams } from "react-router-dom";
import ExperienceGuideInput from "./experience-guide-input";

const ExperiencesEdit = (props) => {
    let { experience } = useParams();
    if (experience === undefined) {
        window.history.replaceState(null, "", "/budget-app/experiences");
    }

    const backToGuideList = () => {
        window.location = "/budget-app/experiences";
    }

    return(
        <PageContainer>
            <Row>
                <Col>
                    <HeaderTitle>

                    </HeaderTitle>
                </Col>
                {!props.client &&
                <Col style={{textAlign: "right"}}>
                    <PrimaryButton style={{marginTop: "30px", marginRight: "30px"}}
                                onClick={(x) => backToGuideList()}> Back to Guide List</PrimaryButton>
                </Col>
                }
            </Row>
            <ExperienceGuideInput id={experience} client={props.client}/>
        </PageContainer>
    )
}

export default ExperiencesEdit;

const PageContainer = styled.div`
    padding: 30px 15px;
    height: 100%;
    box-sizing: border-box;
`;
